import { PaginaParameters } from "./PaginaParameters";

export class TabContentParameters {
  pagina: PaginaParameters;
}
